import { InfoModal } from '@/components/ui/InfoModal'
import VideoLink from '@/components/ui/VideoLink'
import { useVideoBySlug } from '@/hooks/useVideos'

export const InfoDialog = () => {
  const calendarIntegrationOverviewVideo = useVideoBySlug('calendar-integration-overview');
  return (
    <InfoModal
    title="Calendar Integration Overview"
    description={
      <div className="space-y-4">
        <p className="text-sm text-gray-700 mb-4">
          Connect your calendar to enable your AI Employee to create,
          manage, and schedule appointments automatically.
        </p>
        {calendarIntegrationOverviewVideo && <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
          <iframe
            src={calendarIntegrationOverviewVideo || "https://www.loom.com/embed/06e053bdfc2140e69c44828c40b20f54?sid=62df2fbc-51ac-4e98-b3be-b0ca4232dd51"}
            frameBorder="0"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full rounded-lg"
          />
        </div>}
        {calendarIntegrationOverviewVideo && <VideoLink to='calendar-integration-overview' />}

        <div className="space-y-3">
          <div>
            <h4 className="font-medium mb-1">Supported Calendars:</h4>
            <ul className="text-sm space-y-1 text-gray-600">
              <li>
                • <strong>Google Calendar:</strong> Full integration with
                consent flow
              </li>
              <li>
                • <strong>GoHighLevel (Beta):</strong> Native integration
              </li>
              <li>
                • <strong>Outlook Calendar:</strong> Native integration
              </li>
              <li>
                • <strong>Calendly:</strong> Requires paid account
                (Professional/Team/Enterprise)
              </li>
              <li>
                • <strong>Acuity Scheduling:</strong> Native integration
              </li>
              <li>
                • <strong>Square Appointments:</strong> Native integration
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium mb-1">How It Works:</h4>
            <ul className="text-sm space-y-1 text-gray-600">
              <li>
                • <strong>Simple Setup:</strong> Just click connect and
                authorize
              </li>
              <li>
                • <strong>Real-time Sync:</strong> AI can create
                appointments live during calls
              </li>
              <li>
                • <strong>One Calendar:</strong> Only one calendar can be
                active at a time
              </li>
              <li>
                • <strong>Zapier Alternative:</strong> Other calendars can
                be connected via Zapier
              </li>
            </ul>
          </div>
        </div>
      </div>
    }
    triggerClassName="ml-2"
  />
  )
}